import PolicyLayout from "@/components/PolicyLayout";

export default function TermsPage() {
  return (
    <PolicyLayout title="Terms of Service">
      <p>
        These terms govern your use of itspicklewall.com and your purchase of
        Pickle Wall™ products. By using the site or placing an order, you agree
        to shop and interact with us in good faith and in accordance with these
        terms.
      </p>
      <p>
        All product descriptions, pricing, and availability on this site are
        subject to change without notice. Pickle Wall™ and associated marks are
        trademarks of Pickle Wall LLC; the product design is patent pending.
      </p>
      <p>
        Our complete terms of service — covering things like order acceptance,
        limitation of liability, and dispute resolution — are currently being
        finalized with legal counsel and will be published here.
      </p>
      <p>
        If you have a question about a specific order or policy before then,
        please reach out and we'll get you a direct answer.
      </p>
    </PolicyLayout>
  );
}
